import axios from '@/bootstrap'
const endpoint = 'skus'

export default class SkusService {
  list(params) {
    return axios.get(`/api/${endpoint}`, params).then(res => res.data)
  }

  report(params) {
    return axios.get(`/api/${endpoint}/report`, params).then(res => res.data)
  }

  retrieve(id) {
    return axios.get(`/api/${endpoint}/${id}`).then(res => res.data)
  }

  create(data) {
    return axios.post(`/api/${endpoint}`, data).then(res => res.data)
  }

  update(id, data) {
    return axios.put(`/api/${endpoint}/${id}`, data).then(res => res.data)
  }

  delete(id) {
    return axios.delete(`/api/${endpoint}/${id}`).then(res => res.data)
  }

  setSkuDefaultValue(skuId, value) {
    return axios.post(`/api/${endpoint}/${skuId}/default`, { value: value }).then(res => res.data)
  }

  setSkuOverrideValue(skuId, value) {
    return axios.post(`/api/${endpoint}/${skuId}/override`, { value: value }).then(res => res.data)
  }

  deleteSkuOverrideValue(skuId) {
    return axios.delete(`/api/${endpoint}/${skuId}/override`).then(res => res.data)
  }
}
